import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from './translations';

const COOKIE_KEY = 'betaexpress_language';
const DEFAULT_LANGUAGE = 'kk';

function readLanguageCookie() {
  if (typeof document === 'undefined') return null;
  const cookie = document.cookie
    .split('; ')
    .find((item) => item.startsWith(`${COOKIE_KEY}=`));
  return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : null;
}

function getInitialLanguage() {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  const stored = readLanguageCookie();
  return Object.prototype.hasOwnProperty.call(translations, stored) ? stored : DEFAULT_LANGUAGE;
}

const LanguageContext = createContext({
  language: DEFAULT_LANGUAGE,
  setLanguage: () => {},
  t: translations[DEFAULT_LANGUAGE],
});

function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(getInitialLanguage);

  useEffect(() => {
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(language)}; Max-Age=31536000; Path=/; SameSite=Lax`;
    document.documentElement.lang = language === 'kk' ? 'kk' : language;
    document.title = translations[language].meta.title;
    const description = document.querySelector('meta[name="description"]');
    if (description) description.setAttribute('content', translations[language].meta.description);
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t: translations[language],
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

function useLanguage() {
  return useContext(LanguageContext);
}

export { LanguageProvider, useLanguage };
